import { keysToCamel } from "@lib/snakeTocamel"
export const parsePageData = (data) => {
    const widgets = data?.widgets
    if (!widgets || widgets?.length === 0) return []
    const parsedWidgets = []
    const bottomSheets = {}
    let loginSection = {}
    widgets?.forEach((widget) => {
        switch (widget?.key) {
            case "banner_image": {
                parsedWidgets.push({
                    key: widget?.key,
                    image: keysToCamel(widget?.image),
                })
                break
            }
            case "login_section": {
                const { key, header, text } = widget
                loginSection[key] = {
                    key,
                    header: header,
                    text: text,
                    fieldData: keysToCamel(widget.field_data),
                    cta: keysToCamel(widget.cta),
                    gaDetails: widget.ga_details,
                }
                loginSection.key = key
                break
            }
            case "page_ending": {
                const { key, label, link_data } = widget
                loginSection[key] = {
                    key,
                    label,
                    cta: {
                        label: link_data?.label,
                        bottomSheetKey: link_data?.bottom_sheet_name,
                        type: "textual",
                    },
                }
            }
        }
    })
    parsedWidgets.push(loginSection)
    if (data?.bottom_sheets) {
        Object.entries(data.bottom_sheets).map(([key, value]) => {
            bottomSheets[key] = keysToCamel(value)
        })
    }
    return {
        widgets: parsedWidgets,
        bottomSheets,
        gaDetails: data?.ga_details,
        metaData: keysToCamel(data?.meta_data),
    }
}
